import { Injectable } from '@angular/core';
import { DynamicTemplateConfigService } from './dynamic-template-config.service';
import { IPdfTemplate } from './models/pdf-template.interface';
import { A5LandscapeTemplate } from './templates/a5-landscape-template';
import { A4Version4Template } from './templates/a4-version4-template';
import { A5Version1Template } from './templates/a5-version1-template';
import { DefaultThermalTemplate } from './templates/default-thermal-template';
import { DynamicPdfTemplate } from './templates/dynamic-pdf-template';
import { HsncodeThermalTemplate } from './templates/hsn-code-thermal-template';
import { LetterHeadA4Template } from './templates/letter-head-a4-template';
import { MedicalA4Template } from './templates/medical-a4-template';
import { NewJafferTemplate } from './templates/new-jaffer-template';
import { PtrEnterpriseTemplate } from './templates/ptr-enterprise-template';
import { QuotationWithGstTemplate } from './templates/quotation-with-gst';
import { QuotationWithoutGstTemplate } from './templates/quotation-without-gst';
import { RathnaShreeTemplate } from './templates/rathna-shree-template';
import { ThermalVersionTemplate } from './templates/thermal-version-template';
@Injectable({
  providedIn: 'root'
})
export class TemplateRegistryService {
  private templates: Map<string, IPdfTemplate> = new Map();

  constructor(private dynamicConfigService: DynamicTemplateConfigService) {
    this.registerTemplates();
  }

  /**
   * Register all available PDF templates
   */
  private registerTemplates(): void {
    // Register default thermal template
    this.register(new DefaultThermalTemplate());

    // Register static templates (template_id 1-7)
    this.register(new NewJafferTemplate());
    this.register(new RathnaShreeTemplate());
    this.register(new PtrEnterpriseTemplate());
    this.register(new A4Version4Template());
    this.register(new A5Version1Template());
    this.register(new A5LandscapeTemplate());
    this.register(new ThermalVersionTemplate());


    // Register dynamic template handler (template_id >= 8)
    const dynamicTemplate = new DynamicPdfTemplate();
    dynamicTemplate.setConfigService(this.dynamicConfigService);
    this.register(dynamicTemplate);

    // Add more templates here as they are created
    // this.register(new YourNewTemplate());
    this.register(new HsncodeThermalTemplate());
    this.register(new MedicalA4Template());
    this.register(new LetterHeadA4Template());
    this.register(new QuotationWithGstTemplate());
    this.register(new QuotationWithoutGstTemplate());
  }

  /**
   * Register a single template
   */
  private register(template: IPdfTemplate): void {
    const key = template.templateName.toLowerCase().trim();
    console.log(template, 'Template')
    this.templates.set(key, template);
    console.log(`Registered PDF template: ${template.templateName} (${template.pageSize})`);
  }

  /**
   * Get template by name
   * Returns default template if not found
   */
  getTemplate(templateName?: string): IPdfTemplate {
    if (!templateName || templateName.trim() === '') {
      return this.getDefaultTemplate();
    }

    const key = templateName.toLowerCase().trim();
    const template = this.templates.get(key);

    if (!template) {
      console.warn(`Template "${templateName}" not found. Using default template.`);
      return this.getDefaultTemplate();
    }

    return template;
  }

  /**
   * Get default template (thermal printer)
   */
  getDefaultTemplate(): IPdfTemplate {
    return this.templates.get('default')!;
  }

  /**
   * Get all registered templates
   */
  getAllTemplates(): IPdfTemplate[] {
    return Array.from(this.templates.values());
  }

  /**
   * Get all template names
   */
  getTemplateNames(): string[] {
    return Array.from(this.templates.keys());
  }

  /**
   * Check if template exists
   */
  hasTemplate(templateName: string): boolean {
    const key = templateName.toLowerCase().trim();
    return this.templates.has(key);
  }

  /**
   * Get template metadata
   */
  getTemplateInfo(templateName: string): { name: string; version: string; description: string; pageSize: string } | null {
    const template = this.getTemplate(templateName);
    if (!template) return null;

    return {
      name: template.templateName,
      version: template.templateVersion,
      description: template.description,
      pageSize: template.pageSize
    };
  }
}

